import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_ENDPOINTS } from '../constants';

interface TechnologyData {
  technologies: Record<string, string>;
  labels: Record<string, string>;
}

export const useTechnologies = () => {
  return useQuery<TechnologyData>({
    queryKey: ['technologies'],
    queryFn: async () => {
      const response = await axios.get(API_ENDPOINTS.TECHNOLOGIES);
      return response.data;
    }
  });
};

export const useTechnologyValues = () => {
  return useQuery<string[]>({
    queryKey: ['technologyValues'],
    queryFn: async () => {
      const response = await axios.get(`${API_ENDPOINTS.TECHNOLOGIES}/values`);
      return response.data;
    }
  });
};

export const useTechnologyLabels = () => {
  return useQuery<Record<string, string>>({
    queryKey: ['technologyLabels'],
    queryFn: async () => {
      const response = await axios.get(`${API_ENDPOINTS.TECHNOLOGIES}/labels`);
      return response.data;
    }
  });
};
